<div class="map-main">
    <header class="map-main__header">
        <div class="map-main__header__menu">
            @if (nvdbNavigation.isMobileDevice) {
            <div class="map-main__header__logo">
                <img class="ms-3" style="height: 35px" src="assets/img/trafikverket_logo_symbol_only.png" alt="Trafikverkets logotyp" />
            </div>
            <span class="ms-3">{{ nvdbNavigation.siteTitle }}</span>
            } @else if (!nvdbNavigation.hideHamburgerMenu && !trvMapService.trvMap?.showStreetView) {
            <button class="btn btn-link" (click)="menuToggle()">
                <app-svg-icon [svgIcon]="hamburgerIcon"></app-svg-icon>
                <span class="title--small">Meny</span>
                <span class="title--large">{{ nvdbNavigation.siteTitle }}</span>
            </button>
            } @if (nvdbNavigation.hideHamburgerMenu) {
            <button class="btn btn-link" (click)="goToMap()">
                <app-svg-icon [svgIcon]="arrowLeft"></app-svg-icon>
                <span class="ms-2">{{ backText }}</span>
            </button>
            }
        </div>

        @if (!nvdbNavigation.isMobileDevice) {
        <div class="map-main__header__logo">
            <app-svg-icon [svgIcon]="logoIconWithText"></app-svg-icon>
        </div>
        }
        <div class="map-main__header__right">
            @if (environment.application == "JNBKarta"){
                <div class="language-selector">
                <a class="btn btn-link header-btn" [trvTooltip]="lang.GetValue('Lang.Change')" [position]="['bottom']" (click)="toggleDropdown()">
                    <fa-icon [icon]="faGlobe"></fa-icon>
                </a>
                <ul [class.show]="dropdownOpen">
                    <li (click)="selectLanguage('sv')">
                      Svenska
                    </li>
                    <li (click)="selectLanguage('en')">
                      English
                    </li>
                  </ul>
                </div>
            }
            <a class="btn btn-link header-btn" (click)="showReleaseNotesComponent()" [trvTooltip]="'Release notes'" [position]="['bottom']">
                <fa-icon [icon]="faNewspaper"></fa-icon>
            </a>
            <a class="btn btn-link header-btn" (click)="showInfoComponent()" [trvTooltip]="'Info'" [position]="['bottom']">
                <app-svg-icon [svgIcon]="infoCircleIcon"></app-svg-icon>
            </a>
        </div>
    </header>

    <div style="flex: 1" [ngStyle]="{ 'margin-top': !nvdbNavigation.isMobileDevice ? '3.5rem' : '0rem' }">
        <router-outlet></router-outlet>
    </div>

    @if (!nvdbNavigation.isMobileDevice) {
    <footer>
        <div
            class="center-items"
            [style.margin-left.px]="nvdbNavigation.currentPageIsMap && nvdbNavigation.sideBarVisible ? nvdbNavigation.sideBarWidth : 0"
        >
            <div class="me-4 hidden-mobile">{{ lang.GetValue('FooterMenu.Trv') }}</div>
            <div class="me-4 hidden-mobile">781 89 Borlänge</div>
            <div class="me-4 hidden-mobile">Tel 0771-921 921</div>
            <div class="me-4 hidden-mobile">{{ lang.GetValue('FooterMenu.IdNo') }} 202100-6297</div>
            <div class="me-4 hidden-mobile">
                <a title="" [href]="'mailto:' + email" class="text-white">
                    <fa-icon [icon]="faEnvelope" class="me-1"></fa-icon>
                    {{ email }}
                </a>
            </div>
            <div class="me-4">ver.{{ environment.buildVersion }}</div>
        </div>
        <div class="right-items">
            <div class="me-4 hidden-mobile">
                
            </div>
        </div>
    </footer>
    } @if (nvdbNavigation.currentPageIsMap) {
    <app-map-menu #appmenu></app-map-menu>
    }
    
</div>
